<style scoped>
.content-wrapper .content{
	padding-top: 95px;
}
.el-select{
	display: block;
}
.m-t-5{
	margin-top: 10px;
}
button.remove, button.edit{
    padding: 0 10px;
    display: block;
    vertical-align: middle;
}
button.remove span{
	line-height: 1;
	font-size: 30px;
	position: relative;
    top: -2px;
}
button.edit{
	padding: 5px 10px;
}
button.edit i{
	line-height: 1;
	font-size: 17px;
}
.heading-cart{
	position: relative;
	padding-left: 15px;
	padding-right: 15px;
}
.heading-cart a {
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    background: #222;
    color: #fff;
    border-radius: 30px;
    padding: 0 15px;
}
.box-header.with-border{
	margin-bottom: 0;
}
</style>
<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box" v-show="!createFirstImpression && !showeditFirstImpression">
				<div class="box-header with-border heading-cart">
					<h3 class="box-title">Existing Adunits Under First Impression</h3>
					<a href="javascript:void(0);" @click="showCreateForm()">Create First Impression Ad Unit</a>
				</div>
				<div class="box-body">
					<el-table :data="fiExistingAdUnits" style="width: 100%;border-spacing: 0;" v-loading="loading">
						<el-table-column label="" width="50">
							<template slot-scope="scope">
								<div class="text-center">
									<img class="round" width="30" height="30" :avatar="`${scope.row.div_id}`">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="Ad Unit" prop="ad_unit_name"></el-table-column>
						<el-table-column label="Unique id" prop="div_id"></el-table-column>
						<el-table-column label="Selector" prop="selector"></el-table-column>
						<el-table-column label="Dyn. Plcmnt?" width="110">
							<template slot-scope="props">
								{{ props.row.is_dynamic ? 'true' : 'false' }}
							</template>
						</el-table-column>
						<el-table-column label="Activate?" width="120">
							<template slot-scope="scope">
								<!-- {{ props.is_active ? 'true' : 'false' }} -->
								<div class="clearfix" v-if="!scope.row.hb">
									<router-link :to="`${'/admin/publisher/'+ uuid +'/domain/'+ domId +'/buckets/'+ bucketId +'/hb-tags/?tag_id='+ scope.row.id}`">
										<span>Setup HB</span>
									</router-link>
								</div>
								<div class="clearfix" v-if="scope.row.hb">
									<el-switch v-model="scope.row.active" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="Edit" width="60">
							<template slot-scope="props">
								<button class="el-button btn-rounded el-button--success edit" @click="editFirstImpression(props)">
									<i class="ti-pencil"></i>
								</button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<div class="box" v-show="createFirstImpression">
				<div class="box-header with-border">
					<h3 class="box-title">Create First Impression Ad Unit</h3>
				</div>
				<div class="box-body">
					<div class="clearfix" v-show="formData.data.length > 0">
						<h5>Created ad unit</h5>
						<el-table :data="formData.data" style="width:100%;border-spacing:0;">
							<el-table-column label="icon" width="50">
								<template slot-scope="scope">
									<div class="text-center">
										<img class="round" width="30" height="30" :avatar="`${scope.row.div_id}`">
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Unique div id" prop="div_id"></el-table-column>
							<el-table-column label="Selector" prop="selector"></el-table-column>
							<el-table-column label="Ad unit name" prop="ad_unit_name"></el-table-column>
							<el-table-column label="Dyn. Plcmnt?" prop="dp" width="120"></el-table-column>
							<el-table-column label="Remove?" width="90">
								<template slot-scope="props">
									<button class="el-button btn-rounded el-button--danger remove" @click="removeCreatedAdUnit(props.row)">
										<span>&times;</span>
									</button>
								</template>
							</el-table-column>
						</el-table>
						<hr>
					</div>

					<form method="post" name="firstImpression" v-on:submit.prevent="onCreateSubmit" class="form">
						<h5>Select Ad Unit</h5>
						<el-select v-model="formData.adunit" @change="setSelectedAdUnit()" placeholder="Select a adunit" filterable remote :remote-method="getAdunits" :loading="loading">
							<el-option v-for="adunit in adunits" :key="adunit.ad_unit_id" :label="adunit.ad_unit_name" :value="adunit.id"></el-option>
						</el-select>
						<hr>

						<div class="row">
							<div class="col-md-4">
								<h5>Unique Div id</h5>
								<el-input class="publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('divid') }" name="divid" type="text" placeholder="Unique div id" v-model="formData.divid"></el-input>
								<span v-show="errors.has('divid')" class="help is-danger">{{ errors.first('divid') }}</span>
							</div>
							<div class="col-md-3">
								<h5>Dynamic Placement?</h5>
								<div class="m-t-5">
									<el-switch v-model="formData.dynamicPlacement" active-color="#13ce66"></el-switch>
								</div>
							</div>
							<div class="col-md-3">
								<h5>Selector</h5>
								<el-input class="publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('selector') }" name="selector" type="text" placeholder="Selector of element where ad will appear" v-model="formData.selector"></el-input>
								<span v-show="errors.has('selector')" class="help is-danger">{{ errors.first('selector') }}</span>
							</div>
							<div class="col-md-2">
								<h5>Add?</h5>
								<button class="el-button el-button--info" type="button" @click="createAdUnitSpot()">Add</button>
							</div>
						</div>
						<hr>

						<div class="row text-center">
							<button class="el-button el-button--info" type="submit" :disabled="formData.data.length == 0">Save</button>
							<button class="el-button el-button--danger" type="button" @click="cancelForm()">Cancel</button>
						</div>
					</form>
				</div>
			</div>

			<div class="box" v-show="showeditFirstImpression">
				<div class="box-header with-border">
					<h3 class="box-title">Edit First Impression Ad Unit</h3>
				</div>
				<div class="box-body">
					<form method="post" name="firstImpression" v-on:submit.prevent="onEditSubmit" class="form">
						<h5>Select Ad Unit</h5>
						<el-select v-model="editForm.adunit" placeholder="Select a adunit" filterable remote :remote-method="getAdunits" :loading="loading">
							<el-option v-for="adunit in adunits" :key="adunit.ad_unit_id" :label="adunit.ad_unit_name" :value="adunit.id"></el-option>
						</el-select>
						<hr>
						<div class="row">
							<div class="col-md-3">
								<h5>Active?</h5>
								<div class="m-t-5">
									<el-switch v-model="editForm.active" active-color="#13ce66"></el-switch>
								</div>
							</div>
							<div class="col-md-9">
								<h5>Unique Div id</h5>
								<el-input class="publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('edivid') }" name="edivid" type="text" placeholder="Unique div id" v-model="editForm.divid"></el-input>
								<span v-show="errors.has('edivid')" class="help is-danger">{{ errors.first('edivid') }}</span>
							</div>
						</div>

						<hr>
						<div class="row">
							<div class="col-md-3">
								<h5>Dynamic Placement?</h5>
								<div class="m-t-5">
									<el-switch v-model="editForm.dynamicPlacement" active-color="#13ce66"></el-switch>
								</div>
							</div>
							<div class="col-md-9">
								<h5>Selector</h5>
								<el-input class="publisher-input" name="eselector" type="text" placeholder="Selector of element where ad will appear" v-model="editForm.selector"></el-input>
							</div>
						</div>
						<hr>

						<div class="clearfix text-center">
							<button class="el-button el-button--info" type="submit">Save</button>
							<button class="el-button el-button--danger" type="button" @click="cancelForm()">Cancel</button>
						</div>
					</form>
				</div>
			</div>
		</section>
	</div>
</template>
<script type="text/javascript">
	import axios from 'axios';
	import LetterAvatar from '../../../../static/plugins/letterAvatar.js'
	export default {
		data() {
			return {
				uuid: undefined,
				domId: undefined,
				bucketId: undefined,
				credentialId: undefined,
				fiExistingAdUnits: [],
				adunits: [],
				editunitId: undefined,
				selectedUnits: {},
				formData: {
					divid: undefined,
					dynamicPlacement: false,
					selector: undefined,
					adunit: undefined,
					data: []
				},
				editForm: {
					adunit: undefined,
					active: false,
					divid: undefined,
					dynamicPlacement: false,
					selector: undefined
				},
				createFirstImpression: false,
				showeditFirstImpression: false,
				loading: true
			};
		},
		created: function(){
			this.uuid = this.$route.params.uuid;
			this.domId = this.$route.params.domId;
			this.bucketId = this.$route.params.bucketId;

			axios.all([
				axios.get(BASE_URL +'v1/publishers/'+ this.uuid +'/dfp-credentials/'),
				axios.get(BASE_URL +'v1/buckets/'+ this.bucketId +'/get-selected-adunits/'),
			])
			.then(axios.spread((creadentialId, selectedAdUnits) => {
				this.credentialId = creadentialId.data.id;
				this.fiExistingAdUnits = selectedAdUnits.data;
				this.loading = false;

				window.setTimeout(function(){
					LetterAvatar.transform();
				});
			}));
		},
		methods: {
			cancelForm(){
				this.createFirstImpression = false;
				this.showeditFirstImpression = false;
			},
			showCreateForm(){
				this.createFirstImpression = true;
			},
			removeCreatedAdUnit(row){
				let index = this.formData.data.indexOf(row);
				this.formData.data.splice(index, 1);
			},
			createAdUnitSpot(){
				this.formData.data.push({
					bucket: this.bucketId,
					ad_unit_name: this.selectedUnits.ad_unit_name,
					ad_unit: this.formData.adunit,
					div_id: this.formData.divid,
					is_dynamic: this.formData.dynamicPlacement,
					dp: this.formData.dynamicPlacement ? 'true' : 'false',
					selector: (this.formData.dynamicPlacement) ? this.formData.selector : 'N/A',
					is_active: false
				});
				this.formData.divid = undefined;
				this.formData.dynamicPlacement = false;
				this.formData.selector = undefined;

				window.setTimeout(function(){
					LetterAvatar.transform();
				});
			},
			getUnits(){
				axios.all([
					axios.get(BASE_URL +'v1/buckets/'+ this.bucketId +'/get-selected-adunits/'),
				])
				.then(axios.spread((selectedAdUnits) => {
					this.fiExistingAdUnits = selectedAdUnits.data;

					window.setTimeout(function(){
						LetterAvatar.transform();
					});
				}));
			},
			onCreateSubmit(){
				axios.post(BASE_URL + 'v1/buckets/'+ this.bucketId +'/save-selected-adunits/', {
					ad_units: this.formData.data,
				})
				.then(response => {
					if(response.status){
						this.createFirstImpression = this.showeditFirstImpression = false;
						this.formData.data = [];
						this.$notify({
							title: 'Success',
							message: 'Successfully saved adunits for the first impression',
							type: 'success'
						});
						this.getUnits();
					}
				})
				.catch(error => {});
			},
			getAdunits(query){
				if(query){
					axios.all([
						axios.get(BASE_URL +'v1/search-ad-unit/'+ this.domId +'/?query='+ query),
					])
					.then(axios.spread((data) => {
						this.adunits = data.data;
					}))
				}
			},
			setSelectedAdUnit(){
				setTimeout(() => {
					if(this.formData.adunit){
						axios.get(BASE_URL +'v1/get-ad-unit/'+ this.credentialId +'/bucket/'+ this.bucketId +'/?query='+ JSON.stringify([this.formData.adunit]))
						.then((data) => {
							this.selectedUnits = data.data[0];
						})
					}
				});
			},
			editFirstImpression(props){
				// <el-option v-for="adunit in editForm.adunits" :key="adunit.ad_unit_id" :label="adunit.ad_unit_name" :value="adunit.id"></el-option>
				this.editForm.id = props.row.fiid;
				this.editForm.index = this.fiExistingAdUnits.indexOf(props.row);
				this.adunits = [{
					ad_unit_id: props.row.ad_unit_id,
					ad_unit_name: props.row.ad_unit_name,
					id: props.row.id,
				}];
				this.editForm.adunit = props.row.id;

				this.editForm.active = props.row.is_active;
				this.editForm.divid = props.row.div_id;
				this.editForm.dynamicPlacement = props.row.is_dynamic;
				this.editForm.selector = props.row.selector == 'N/A' ? undefined : props.row.selector;
				this.createFirstImpression = false;
				this.showeditFirstImpression = true;
			},
			onEditSubmit(){
				let tempObject = {
					id: this.editForm.id,
					bucket: this.bucketId,
					ad_unit: this.editForm.adunit,
					div_id: this.editForm.divid,
					selector: this.editForm.selector ? this.editForm.selector : 'N/A',
					is_dynamic: this.editForm.dynamicPlacement,
					is_active: this.editForm.active
				}

				axios.post(BASE_URL + 'v1/buckets/'+ this.bucketId +'/save-fi-adunit/'+ this.editForm.id +'/', tempObject)
				.then(response => {
					this.createFirstImpression = this.showeditFirstImpression = false;
					this.$notify({
						title: 'Success',
						message: 'Successfully edited adunits for the first impression',
						type: 'success'
					});
					this.getUnits();
				})
				.catch(error => {});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// FirstImpression.vue?71eb182c